import React from "react";
import { Link } from "react-router-dom";
import Button from "../../../../components/form/Button";
import { useSelector } from "react-redux";
import { t } from "i18next";

const Thankyou = () => {
  const { lang } = useSelector((state) => state?.langProvider);

  return (
    <section className="relative py-24 bg-magnolia">
      <div className="max-w-6xl 2xl:max-w-8xl 3xl:max-w-9xl w-full mx-auto relative">
        <div className="space-y-4 flex flex-col items-center justify-center">
          <div className="bg-primary-gradient w-12 aspect-square rounded-full flex items-center justify-center text-2xl font-bold text-white">
            <i className="fa-regular fa-check"></i>
          </div>
          <h1 className="text-2xl font-bold text-slate-800 mb-2">
            {t("Thank You for your Order")}
            {/*  #1236467383 */}
          </h1>

          <Button
            buttonLabel={t("Take me to my tickets")}
            buttonHasLink={true}
            buttonLink={`/${lang}/tickets-order`}
          />
        </div>
      </div>
    </section>
  );
};

export default Thankyou;
